import { defineFcm } from '../shared/factory';

export const FCM_ENABLE_ADVOCATES_IDENTIFIED_EXPERIMENT = defineFcm('enable_advocates_identified_experiment')
	.asBoolean()
	.withDefault(false)
	.toConfig();
